import { useContent } from "@/context/ContentContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

export default function Landing() {
  const { content, loading } = useContent();

  if (loading || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50" data-testid="landing-loading">
        <div className="font-display text-3xl uppercase tracking-tight">MER Home Improvement</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-50" data-testid="landing-page">
      <Navbar content={content} />
      <Hero content={content} />
      <Marquee content={content} />
      <Services content={content} />
      <About content={content} />
      <Gallery content={content} />
      <Testimonials content={content} />
      <Contact content={content} />
      <Footer content={content} />
      <StickyMobileCTA content={content} />
    </div>
  );
}
